<template>
    <li class="alternatives-list-item">
        <div :class="`alternatives-list-item__wrapper${(item.recommended ? ` alternatives-list-item__wrapper--recommended` : '')}${(hasSelectedAlternative ? ` alternatives-list-item__wrapper--unselected-alt` : '')}`">
            <div class="alternatives-list-item__title alternatives-list-item__title--small"
                 tabindex="0"
                 @click="$emit('view-info', item)"
                 @keyup.enter="$emit('view-info', item)">
                {{ displayTitle }}
            </div>
            <div class="alternatives-list-item__title alternatives-list-item__title--full"
                 tabindex="0"
                 @click="$emit('view-info', item)"
                 @keyup.enter="$emit('view-info', item)">
                {{ item.title }}
            </div>
            <span class="alternatives-list-item__price"><span v-if="!$scheme.priceless">{{ item.priceDisplay }}</span></span>
            <section class="alternatives-list-item__buttons">
                <hh-tooltip text="View details about this item"
                            position="top-left"
                            right-left-position-adjust="-25%">
                    <hh-icon-btn class="alternatives-list-item__buttons__btn"
                                 root-class="alternatives-list-item__buttons__info"
                                 icon="info"
                                 @click="$emit('view-info', item)" />
                </hh-tooltip>
            </section>
        </div>
    </li>
</template>

<script>

export default {

    props: {
        item: {
            type: Object,
            required: true,
        },
        hasSelectedAlternative: {
            type: Boolean,
            default: false,
        },
        maxLength: {
            type: Number,
            default: 52,
        },
    },

    computed: {

        displayTitle() {
            return this.item.title.length < this.maxLength + 5
                ? this.item.title
                : `${ this.shortTitle }…`
        },

        shortTitle() {
            const shortened = this.item.title.substring(0, this.maxLength + 1)
            return shortened.substring(0, shortened.lastIndexOf(' '))
        },
    },
}

</script>

<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.
// src\scss\schemes\components\app-core\_alternatives-list-item.scss

.alternatives-list-item {
    margin: 5px 0;

    @include bp-min-small {
        flex: 1 1 50%;
    }

    @include element('wrapper') {
        padding: $icon-list-padding;
        display: flex;
        flex-wrap: nowrap;
        flex-flow: row;
        justify-content: space-between;
        align-items: center;
        position: relative;
        @include user-select-none;

        @include bp-min-mid {
            border-left-width: 1px;
            border-right-width: 1px;
        }
    }

    @include element('title') {
        flex: 1 1 auto;
        line-height: 1rem;
        margin-left: 0.2rem;

        @include modifier('small') {

            @include bp-min-small {
                display: inline;
            }

            @include bp-min-wide {
                display: none;
            }
        }

        @include modifier('full') {
            display : none;

            @include bp-min-wide {
                display: inline;
            }
        }
    }

    @include element('price') {
        flex: 0 0 auto;
        display: block;
        margin-left: 0.2rem;
    }

    @include element('buttons') {
        flex: 0 0 auto;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: space-between;
        position: relative;
        left: 0.2rem;

        @include bp-min-mid {
            font-size: 1rem;
        }

        @include element('info') {
            position: relative;
            top: -1px;
        }
    }
}

</style>
